import { ApolloError } from "@apollo/client";

interface Props {
  error: ApolloError;
}

export const EventError = ({ error }: Props) => {
  if (!error) {
    return null;
  }

  let errorText =
    "There was an error creating this event. Please check your innputs!";

  switch (error.message) {
    case 'Uniqueness violation. duplicate key value violates unique constraint "events_slug_key"':
      errorText = "An event with this title already exists.";
      break;

    default:
      break;
  }

  return (
    <section className='bg-red-50 border-red-300 border rounded-md px-4 py-2 text-red-900 flex flex-col space-y-4'>
      <h2 className='header underline'>Error</h2>
      <p className=''>{errorText}</p>
      <div className='bg-white p-2 rounded-md'>
        <p className='text-sm'>
          If you don't think this error should be happening, or the message
          above is not helpful to you, copy the garbled text below and send it
          to your wonderful developer!
        </p>
        <p className='text-sm text-gray-500'>
          {JSON.stringify(error, undefined, 2)}
        </p>
      </div>
    </section>
  );
};
